<div class="flex_sa flex_column p-t-14">
    <img [src]="images.NO_INVOICE_DATA" class="no-data-img" alt="No-Data"/>
    <p class="fw-700 fs-20 clr-333">{{'NO_DATA.NO_DATA' | fallbackTranslate}}</p>
</div>